<template>
  <view class="popup-warp">
    <view class="popup" wx:class="{{popupClass}}">
      <view class="title">专属优惠券已到账</view>
      <view wx:if="{{__mpx_mode__ === 'web'}}" class="coupon-list" scroll-y="{{true}}" bind:scroll="scroll">
        <view class="content">
          <view wx:for="{{couponList}}" wx:key="index" class="coupon {{couponList.length === 1 ? 'coupon-one' : ''}}">
            <view class="left">
              <coupon-price couponInfo="{{item.coupon}}" type="popup-result"/>
            </view>
            <view class="right">
              <view class="info">
                <view class="name">{{item.coupon.name}}</view>
                <view wx:if="{{item.coupon.usage_limit}}" class="usage-limit">{{item.coupon.usage_limit}}</view>
                <view wx:if="{{item.coupon.valid_period}}" class="valid-period">{{item.coupon.valid_period}}</view>
              </view>
            </view>
          </view>
        </view>
      </view>
      <scroll-view wx:else class="coupon-list" scroll-y="{{true}}" bind:scroll="scroll">
        <view class="content">
          <view wx:for="{{couponList}}" wx:key="index" class="coupon {{couponList.length === 1 ? 'coupon-one' : ''}}">
            <view class="left">
              <coupon-price couponInfo="{{item.coupon}}" type="popup-result"/>
            </view>
            <view class="right">
              <view class="info">
                <view class="name">{{item.coupon.name}}</view>
                <view wx:if="{{item.coupon.usage_limit}}" class="usage-limit">{{item.coupon.usage_limit}}</view>
                <view wx:if="{{item.coupon.valid_period}}" class="valid-period">{{item.coupon.valid_period}}</view>
              </view>
            </view>
          </view>
        </view>
      </scroll-view>
      <view class="footer">
        <image wx:if="{{ popupClass === 'is-more-3' }}" class="arrow-icon {{showMoreArrow ? 'is-visible' : ''}}" src="https://ut-static.udache.com/webx/ut/obhYNk1zIRZYShrz_riyh.png" mode="widthFix" />
        <button class="btn" catchtap="click">{{btnText}}</button>
      </view>
      <image bindtap="close" class="icon-close" src="https://ut-static.udache.com/webx/ut/WIUg8eH8cGpP8fLQhM-Xj.png" mode="widthFix" />
      <view class="owner-tip">-  本活动由滴滴出行网络平台推送  -</view>
    </view>
  </view>
</template>


<script>
import { createComponent } from '@mpxjs/core'
import { trackEvent } from '@didi/webx-js'
import { gotoLink } from '../../lib/utils.js'
createComponent({
  properties: {
    popupData: Object,
    pageConfig: Object,
  },
  attached() {
    trackEvent('userteam_fx_dialog_pg_sw', '领券弹窗展现')
  },
  data: {
    showMoreArrow: true,
  },
  computed: {
    btnText() {
      if (this.popupData?.coupon_txt) {
        return this.popupData?.coupon_txt
      }
      return this.pageConfig?.popup?.button?.text || '去使用'
    },
    couponList() {
      return this.popupData.rewards
    },
    popupClass() {
      if (this.couponList.length > 2) {
        return 'is-more-3'
      } else {
        return `is-more-${this.couponList.length }`
      }
    },
  },
  methods: {
    close() {
      this.triggerEvent('close')
    },
    click() {
      if (this.popupData?.coupon_link) {
        gotoLink(this.popupData?.coupon_link)
      } else {
        this.triggerEvent('click')
      }
    },
    scroll(e) {
      const offset = 10
      if (__mpx_mode__ === 'web') {
        this.showMoreArrow = e.srcElement.scrollTop + e.srcElement.getBoundingClientRect().height < e.srcElement.scrollHeight - offset
      } else {
        this.showMoreArrow = e.detail.scrollTop + this.height < e.detail.scrollHeight - offset
      }
    },
  },
})
</script>

<style lang="stylus" scoped>
.popup-warp
  z-index 99
  width 100%
  height 100%
  position fixed
  top: 0
  left 0
  background-color: rgba(0,0,0,.85)
  display: flex;
  justify-content: center;
  align-items center
  .owner-tip
    position: absolute;
    width: 100%;
    bottom: -60rpx;
    white-space: pre;
    font-size 18rpx
    color #fff
    text-align center
  .icon-close
    width 50rpx
    height 50rpx
    position absolute
    left 50%
    bottom -140rpx
    transform translate(-50%)
  .popup
    position relative
    box-sizing border-box
    width 620rpx
    height 806rpx
    background-image: url('https://ut-static.udache.com/webx/ut/51udP-kK08gcZpQwQrXbK.png')
    background-size 100% auto
    &.is-more-1
      height 680rpx
      background-image: url('https://ut-static.udache.com/webx/ut/fbfYzaHtb51Gemg6TLim2.png')
      .title
        margin-top 55rpx
        margin-bottom 52rpx
    &.is-more-2
      height 680rpx
      background-image: url('https://ut-static.udache.com/webx/ut/fbfYzaHtb51Gemg6TLim2.png')
    &.is-more-3
      .coupon-list
        height 480rpx
        .content
          padding-bottom 20rpx
    .coupon-list
      display: flex;
      justify-content: center;
      // height 380rpx
      box-sizing: border-box;
      overflow-y auto
      &::-webkit-scrollbar
        display: none;
      .content
        display: flex;
        flex-direction: column;
        align-items: center;
        .coupon
          flex-shrink: 0;
          width 570rpx
          height 180rpx
          background-image: url('https://ut-static.udache.com/webx/ut/vWwmREOtPbvz1F8g7CM3u.png')
          background-size: 100% auto
          background-repeat: no-repeat
          background-size 100% auto
          display flex
          padding 0rpx 20rpx 18rpx 16rpx
          box-sizing border-box
          &.coupon-one
            background-image: url('https://ut-static.udache.com/webx/ut/iypn6PsrD4POCeyVeX-76.png')
            width: 570rpx
            height: 249rpx
            padding-bottom: 28rpx
          .left
            flex 1
            position relative
          .right
            width 322rpx
            box-sizing border-box
            display flex
            align-items: center;

            .info
              flex: 1;
              margin-left 44rpx
              .name
                line-height 1
                width: 260rpx;
                height: 45rpx;
                line-height: 45rpx;
                font-family: PingFangSC-Medium;
                font-size: 32rpx;
                color: #ffffff;
                letter-spacing: 0;
                font-weight: 600;
                margin-bottom 10rpx
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              .usage-limit, .valid-period
                font-size: 16rpx;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                color: #ffffff;
                height: 22rpx;
                line-height 22rpx
                margin-bottom 10rpx
    .title
      text-align center
      letter-spacing: 0;
      margin-top 25rpx
      margin-bottom 25rpx
      font-size: 42rpx;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #FC5E23;
      -webkit-background-clip: text;
    .footer
      background-image url('https://ut-static.udache.com/webx/ut/orMAhP2Zg_WiYTsjVnhrJ.png')
      background-size 100% auto
      width 97%
      height 269rpx
      position absolute
      bottom 0rpx
      left 0
      right 0
      margin 0 auto
      text-align center
      .arrow-icon
        width 33rpx
        margin-top 23rpx
        transition opacity 0.5s
        opacity 0
        &.is-visible
          opacity 1
    .btn
      z-index 9
      position absolute
      bottom 0
      left 0
      right 0
      background-image: url('https://ut-static.udache.com/webx/ut/TXtJ0fIFo4BH96D8zB8j3.png')
      background-size: cover
      width 540rpx
      height 160rpx
      // line-height 110rpx
      text-align center
      font-family: PingFang SC;
      font-size: 48rpx;
      font-weight: bold;
      color: #ffffff;
      background-color: transparent;
      &::after
        border none
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {
    "coupon-price": "./coupon-price-cz.mpx"
  }
}
</script>
